import React, { PureComponent } from "react";
import centralAPI from "../../CentralAPIHandler/CentralAPIHandler";
import View360HelperText from "./View360HelperText";
import Styles from "../../Css/View360/View360.module.css";

// import Switch from "react-switch";
import "animate.css";
import { OverlayTrigger, Tooltip, Modal } from "react-bootstrap";
import View360Slider from "./View360Slider";
import View360FallbackUI from "./View360FallbackUI";
import Loader from "../Loader";
// redux
import { connect } from "react-redux";
import { updateWholeHotSpotMapObj } from "../../Redux/Reducers/View360Reducer/View360ActionController";
import Switch from "@mui/material/Switch";
import { createTheme, ThemeProvider } from "@mui/material/styles";
// zoom in and out
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { singleData } from "./config";
import ToggleButton from "./ToggleButton";
import MobileViewSlider from "./MobileViewSlider";

export let firstPic = '';

class View360 extends PureComponent {
  rotateInterval = false;
  constructor(props) {
    super(props);
    this.elementRef = React.createRef();
    this.imageRefsF = []; // Array to store refs for each image
    this.imageRefsS = []; // Array to store refs for each image
    this.dragSpeed = 5;
    this.isRequestFor3DModel = false;
    this.isInput360Requested = false;
    this.autoRotateBl = false;
    /* setting the state variables */
    if (this.props && this.props.dragSpeed) {
      this.dragSpeed = this.props.dragSpeed;
    }
    let { imageCategory, type } = this.getSkuIdAndImageCategory();
    if (imageCategory && imageCategory === "3D_Model") {
      this.isRequestFor3DModel = true;
    } else if (type && type === "input") {
      this.isInput360Requested = true;
    }
    this.state = {
      images: [],
      imageIndex: 0,
      noOfImg: 0,
      oldx: 0,
      loading: true,
      imgId: "",
      hotSpotsToMap: [],
      dragSpeed: this.dragSpeed,
      autoRotate: this.autoRotateBl,
      hotSpotModal: {
        show: false,
      },
      freshLoad: true,
      toggleHotspotView: true,
      imageNewDimensions: {
        isNewDimensionsUpdated: false,
        isPadByWidth: false,
        newImgWidth: 1,
        newImgHeight: 1,
        newContainerWidth: 1,
        newContainerHeight: 1,
        paddingHalf: 0,
      },
      modalList: new Map(),
      errStatus: {
        code: 500, // handle errors
        show: false,
      },
      goToSlide: 0, // open this slide on modal,
      lazyLoadImages: false,
      renderHotSpots: false,
      isAnyHotSpotPresent: false,
      isRequestFor3DModel: this.isRequestFor3DModel,
      isInput360Requested: this.isInput360Requested,
      isZoomActive: false,
      currentZoomLevel: 100,
      showHelperText: true,
      showExtOrInt: "EXT",
      isLoaded: false,
      interior360Url: [],
      showValue: {},
      animationEnd: {},
      zoomValue: 0,
      selectedHotspotObjKey: null,
      activeHotspot: null,
      isAnyFocusImage: true,
      hotspotActiveValue: null,
      imageLoaded: false,
      notMoveImageOnHover: false,
      spinMotion: true,
      playerType: "sbs",
      dataProvider: "spn",
      guideLineDisplay: "none",
      rotateReverse:false,
      rotateAntiClock:true,

      hotspotsDisplay: this.autoRotateBl ? "none" : "block",
    };

    this.handleHotSpotViewToggle = this.handleHotSpotViewToggle.bind(this);

    this.zoomInBtn = React.createRef();
    this.zoomOutBtn = React.createRef();
    this.resetBtn = React.createRef();
    this.transformRef = React.createRef();
    window.View360Reference = this;
  }

  componentDidMount = async () => {
    // track window resize, and update NewImageDimensions
    window.addEventListener("resize", this.updateNewImageDimensions);

    await this.fetchImages();
    document.addEventListener("keydown", this.handleKeyDown);

    /* OnMessage Events for CVDP */
    if (window.addEventListener) {
      window.addEventListener(
        "message",
        (event) => {
          // console.log("Message received:", event);
          this.onMessageGeneral(event);
        },
        false
      );
    } else if (window.attachEvent) {
      window.addEventListener(
        "onmessage",
        (event) => {
          // console.log("Message received:", event);
          this.onMessageGeneral(event);
        },
        false
      );
    }

    this.startAutoRotate();

    /* touch event listeners since it is not working */
    // this.imageRefsF.forEach((imageRef) => {
    //     if (imageRef) {
    //         imageRef.addEventListener('touchstart', this.handleTouchStarted, { passive: false });
    //     }
    // });

    // this.imageRefsS.forEach((imageRef) => {
    //     if (imageRef) {
    //         imageRef.addEventListener('touchstart', this.handleTouchStarted, { passive: false });
    //     }
    // });
  };

  componentWillUnmount() {
    document.addEventListener("keydown", this.handleKeyDown);
    window.removeEventListener("resize", this.updateNewImageDimensions);
    window.removeEventListener("message", this.onMessageGeneral);
    window.removeEventListener("onmessage", this.onMessageGeneral);
    this.stopAutoRotate();

    // this.imageRefsF.forEach((imageRef) => {
    //     if (imageRef) {
    //         imageRef.removeEventListener('touchstart', this.handleTouchStarted);
    //     }
    // });

    // this.imageRefsS.forEach((imageRef) => {
    //     if (imageRef) {
    //         imageRef.removeEventListener('touchstart', this.handleTouchStarted);
    //     }
    // });
  }

  startAutoRotate = () => {
    if (this.rotateInterval) {
      //multiple mount calls why check later
      clearInterval(this.rotateInterval);
    }
    this.rotateInterval = setInterval(() => {
      if (this.state.autoRotate) {
        this.autoRotate(this.rotateAntiClock);
      } else {
        this.stopAutoRotate();
      }
    }, 200);
  };

  stopAutoRotate = () => {
    if (this.rotateInterval) {
      clearInterval(this.rotateInterval);
      this.rotateInterval = null; // Important: Reset to null
    }
  };

  onMessageGeneral = async (event) => {
    const data = event.data;
    // console.log(data, "Event triggered");
    if (data.func === "previewPOIMobileDecrement") {
      // console.log("inside the onMessage");
      this.decrement(true, true);
    } else if (data.func === "previewPOIMobileIncrement") {
      // console.log("inside the onMessage");
      this.increment(true, true);
    } else if (data.func === "previewPOIMobileCurrentPOI") {
      this.openCurrentPOI(data.image_text);
    }
  };

  getSkuIdAndImageCategory = () => {
    try {
      const queryParams = new URLSearchParams(window.location.search);
      const skuId = queryParams.get("sku_id");
      const imageCategory = queryParams.get("image_category");
      let image_type = queryParams.get("image_type");
      let vin = queryParams.get("vin");
      let project_id = queryParams.get("project_id");
      let library_id = queryParams.get("library_id");
      let type = queryParams.get("type");
      let hotspot_val = queryParams.get("hotspot");
      let skuName = queryParams.get("sku_name");
      let enterpriseId = queryParams.get("enterprise_id");
      let spinMotion = queryParams?.get("spin_motion");
      this.playerType = queryParams.get("player_type");
      this.dataProvider = queryParams.get("data_provider");
      this.spinSpeed = queryParams.get("spin_speed");
      this.switchHotspot = queryParams.get("switch_hotspot");
      this.mobileMode = queryParams.get("mobile_mode");
      this.hideHotspotBtn = queryParams.get("hide_hotspot_btn");
      this.autoRotateBl = queryParams.get("auto_rotate");
      this.FullScreenScaleup = queryParams.get("fullScreenSclUp");
      this.rotateReverse = queryParams.get("rotateReverse");
      if (this.spinSpeed == null) this.spinSpeed = 100;
      if (project_id == null) project_id = "";
      if (library_id == null) library_id = "";
      if (vin == null) vin = "";

      if (this.playerType == null) this.playerType = "sbs";

      if (this.dataProvider == null) {
        this.dataProvider = "spn";
        this.playerType = "full";
      }

      if (this.rotateReverse && this.rotateReverse === '1'){
        this.rotateAntiClock = true;
      }
      else{
        this.rotateAntiClock = false;
      }

      if (!type) type = "output";
      if (!image_type) image_type = "spn";

      hotspot_val = hotspot_val == "false" ? false : true;
      this.switchHotspot = this.switchHotspot == "false" ? false : true;
      this.mobileMode = this.mobileMode == "true" ? true : false;
      this.hideHotspotBtn = this.hideHotspotBtn == "true" ? true : false;
      this.autoRotateBl = this.autoRotateBl == "true" ? true : false;
      /* check if it is phone or ipad */
      // if(window?.innerWidth < 300)
      //     hotspot_val = false;
      //, vin, project_id, library_id, image_type
      return {
        skuId,
        imageCategory,
        type,
        skuName,
        enterpriseId,
        hotspot_val,
        spinMotion,
        vin,
        project_id,
        library_id,
        image_type,
      };
    } catch (error) {
      console.log(error);
    }
  };
  /**
   * Fetch images and hotspots from db
   * @returns
   */
  fetchImages = async () => {
    //alert(window?.parent.window.innerWidth);
    try {
      //, vin, project_id, library_id, image_type
      const {
        skuId,
        imageCategory,
        type,
        skuName,
        enterpriseId,
        hotspot_val,
        spinMotion,
        vin,
        project_id,
        library_id,
        image_type,
      } = this.getSkuIdAndImageCategory();
      const images = [];
      const allImageInObject = {};

      if (!skuId && !skuName) return;

      // const URL = `add your own url`
      let URL = `https://kkcfmy2blfm6xdh5ardeebgpfu0lyxmm.lambda-url.us-east-1.on.aws/`;

      if (this.dataProvider == "spn")
        URL = "https://prod-360-api.tech-dc2.workers.dev/";

      var params = {};

      params = {
        image_type: image_type,
        project_id: project_id,
        vin: vin,
        library_id: library_id,
        skuId: skuId,
        type: type,
      };
      //console.log(params)
      const { skuDetails, interior360Data } = await centralAPI.handleGetRequest(
        URL,
        params
      );
      if (!skuDetails || !skuDetails.length)
        throw Error(
          "Fetch req successful, still skuDetails came out as null or empty array"
        );

      const allImageIDs = [];
      // console.log("Image Data",skuDetails[0]['output_image_hres_url']);
      firstPic = skuDetails[0]['output_image_hres_url'];
      
      this.setFirstPic();
      skuDetails.forEach((image) => {
        
        let originalUrl = image["output_image_hres_url"];
        //Updated for scale up on fullScreen
        if(this.FullScreenScaleup == "1"){
          originalUrl = originalUrl.replace(/(w=)(\d+)/, "w=1920");
        }
      
        allImageInObject[image["image_id"]] = {
        src: originalUrl,
        imageId: image["image_id"],
        imageName: image["image_name"],
        };
        images.push({
          src: originalUrl,
          imageId: image["image_id"],
          imageName: image["image_name"],
        });
        allImageIDs.push(image["image_id"]);
        
        //console.log(originalUrl);
        /*
          if(window?.innerWidth < 500){
              originalUrl = `add your own api path` + originalUrl

          }else{
              originalUrl = 'add your own api path' + originalUrl
          }
          */
        
      });
      //console.log("AAIDS", allImageIDs);
      let hotSpotMapURL =
        "https://ljw9dc2yxc.execute-api.us-east-1.amazonaws.com/spin-poi/api?id=" +
        project_id +
        "-" +
        vin.toLowerCase() +
        "&type=spn";

      // console.log("hotSpotMapURL");

      if (this.dataProvider == "spn") {
        hotSpotMapURL = "https://www.clippr.ai/api/v1/hotspot/get-hotspots";
      }

      let mapping = await centralAPI.handleGetRequest(hotSpotMapURL, {
        skuId: skuId,
      });
      // console.log("Mappings - ", mapping);
      if (mapping && mapping.hotspots) {
        this.setHotSpotMapObjInStore(
          mapping,
          images,
          type === "input",
          interior360Data,
          allImageInObject,
          hotspot_val,
          spinMotion
        );
      } else {
        if (mapping) {
          mapping.hotspots = [];
        } else {
          mapping = {};
          mapping.hotspots = [];
        }
        this.setHotSpotMapObjInStore(
          mapping,
          images,
          type === "input",
          interior360Data,
          allImageInObject,
          hotspot_val,
          spinMotion
        );
      }
    } catch (error) {
      if (error && error.message && error.message.match(/404/gim)) {
        this.setState({
          ...this.state,
          loading: false,
          errStatus: { code: 404, show: true },
        });
      }
      console.log(error);
    }
    window.parent.postMessage({ playerReady: true }, "*");
  };

  /**
   * Create hotspot mapping, if isHidden is false
   * and hotSpotMap
   * @param {*} mapping
   */
  setHotSpotMapObjInStore = (
    mapping,
    images,
    isInputRequested = false,
    interior360Data,
    allImageInObject,
    hotspot_val,
    spinMotion
  ) => {
    try {
      //console.log(mapping.hotspots);

      const newHotSpotMapObj = new Map();

      const newModalList = new Map(); // {title, desc, url, closeUpURL, hotSpotId}
      /**
       * imageId use as map key, if isHidden is false
       *
       * if the hotSpots array contains elements, put them under this imageId,
       * else leave as it is
       *
       */
      let isAnyHotSpotPresent = false;
      // console.log(mapping )
      // debugger
      let isAnyFocusImage = true;
      mapping?.hotspots[0]?.exterior_tagged_images?.forEach((element) => {
        // debugger
        const { image_id, hotspots } = element;
        if (!allImageInObject[image_id]) return;
        const newImageHotSpots = new Map();
        //console.log('element',element)
        // if(!isHidden){
        hotspots.forEach((hotSpotObj) => {
          if (hotSpotObj?.focus_image_url) isAnyFocusImage = true;
          // mark 'isAnyHotSpotPresent' true if hot spot present

          if (isInputRequested) {
            // here we are setting input coordinates as coordinates to let the flow work same as it works for output
            hotSpotObj["coordinates"] = {
              x: hotSpotObj?.coordinates?.x,
              y: hotSpotObj?.coordinates?.y,
            };
          }

          isAnyHotSpotPresent = true;
          newImageHotSpots.set(hotSpotObj.hotspot_id, { ...hotSpotObj });
          // set modal-list, if this id is not there in newModalList
          if (!newModalList.has(hotSpotObj.hotspot_id)) {
            newModalList.set(hotSpotObj.hotspot_id, {
              title: hotSpotObj.type || "",
              desc: hotSpotObj.reasons?.[0] || "",
              url:
                "data:image/svg+xml;base64," +
                btoa(
                  '<svg width="100px" height="100px" viewBox="0 0 32.00 32.00" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" fill="#01BBEE"><g id="SVGRepo_bgCarrier" stroke-width="0"><rect x="0" y="0" width="32.00" height="32.00" rx="16" fill="#FFFFFF" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>plus-circle</title> <desc>Created with Sketch Beta.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"> <g id="Icon-Set-Filled" sketch:type="MSLayerGroup" transform="translate(-466.000000, -1089.000000)" fill="#01BBEE"> <path d="M488,1106 L483,1106 L483,1111 C483,1111.55 482.553,1112 482,1112 C481.447,1112 481,1111.55 481,1111 L481,1106 L476,1106 C475.447,1106 475,1105.55 475,1105 C475,1104.45 475.447,1104 476,1104 L481,1104 L481,1099 C481,1098.45 481.447,1098 482,1098 C482.553,1098 483,1098.45 483,1099 L483,1104 L488,1104 C488.553,1104 489,1104.45 489,1105 C489,1105.55 488.553,1106 488,1106 L488,1106 Z M482,1089 C473.163,1089 466,1096.16 466,1105 C466,1113.84 473.163,1121 482,1121 C490.837,1121 498,1113.84 498,1105 C498,1096.16 490.837,1089 482,1089 L482,1089 Z" id="plus-circle" sketch:type="MSShapeGroup"> </path> </g> </g> </g></svg>'
                ),
              // url: hotSpotObj.hotspot_icon || '',
              closeUpURL: hotSpotObj?.focus_image_url
                ? hotSpotObj?.focus_image_url
                : "",
              image_id: image_id,
            });
          }
        });

        // }
        newHotSpotMapObj.set(image_id, {
          isHidden: false,
          imageHotSpots: newImageHotSpots,
        });
      });

      this.props.updateWholeHotSpotMapObj(newHotSpotMapObj);
      // load the original content and set loading page to false

      this.setState((prevState) => ({
        ...prevState,
        images: [...images],
        noOfImg: images.length || 0,
        modalList: newModalList,
        isAnyHotSpotPresent: isAnyHotSpotPresent ? hotspot_val : false,
        interior360Url: interior360Data,
        isAnyFocusImage: isAnyFocusImage,
        imgId: images?.[0]?.imageId || "",
        toggleHotspotView: this.switchHotspot,
        spinMotion: spinMotion ? true : false,
      }));

      // stop loading after 100ms
      setTimeout(() => {
        this.setState({ ...this.state, loading: false, lazyLoadImages: true });
      }, 100);
    } catch (error) {
      console.log(error);

      this.setState({
        ...this.state,
        loading: false,
        lazyLoadImages: true,
      });
    }
  };

  setImageSrcInPlaceOfCloseUpURL = (imageIdToMatch, imagesList) => {
    let imgSrc = "";
    try {
      for (let i = 0; i < imagesList.length; i++) {
        const { src, imageId } = imagesList[i];

        if (imageIdToMatch === imageId) {
          imgSrc = src;
          break;
        }
      }
    } catch (error) {
      console.log(error)
    }

    return imgSrc;
  };

  /* Auto Rotate the car */
  autoRotate(moveRight = false) {
    try {
      if (this.state.images == 0) {
        // console.log("no data initialized yet");
        return;
      }
      this.setState((prevState) => ({
        ...prevState,
        hotspotsDisplay: "none",
      }));
      let framesAtOnce = 1;
      if (this.state.noOfImg >= 150) {
        framesAtOnce = 2;
      }
      if (this.state.noOfImg >= 200) {
        framesAtOnce = 3;
      }

      if (!this.state.imageNewDimensions.isNewDimensionsUpdated)
        this.updateNewImageDimensions();

      let perImgSpeed = Math.floor(
        this.state.imageNewDimensions.newContainerWidth /
          (2 * this.state.images.length)
      );

      this.setState((prev) => ({
        ...prev,
        renderHotSpots: !this.state.renderHotSpots,
        dragSpeed: perImgSpeed,
      }));
      let newIndex = null;
      if (!moveRight) {
        let right =
          (parseInt(this.state.imageIndex) + 1) % parseInt(this.state.noOfImg);
        newIndex = right;
      } else {
        let left =
          this.state.imageIndex - 1 < 0
            ? this.state.noOfImg - 1
            : this.state.imageIndex - 1;
        newIndex = left;
      }
      if (newIndex !== null && newIndex !== this.state.imageIndex) {
        // console.log({ oldIndex: this.state.imageIndex, newIndex: newIndex });
        this.setState((prev) => ({
          ...prev,
          imageIndex: newIndex,
          imgId: this.state.images[newIndex].imageId,
          notMoveImageOnHover: true,
        }));
      }
    } catch (error) {
      console.log(error);
      this.setState({ ...this.state, hotspotsDisplay: "block" });
    }
  }

  /**
   * Mouse move handle
   * @param {*} e
   */
  move = (e) => {
    try {
      this.setState((prevState) => ({
        ...prevState,
        hotspotsDisplay: "none",
      }));
      let framesAtOnce = 1;
      if (this.state.noOfImg >= 100) {
        framesAtOnce = 2;
      }
      if (this.state.noOfImg >= 150) {
        framesAtOnce = 3;
      }

      if (!this.state.imageNewDimensions.isNewDimensionsUpdated)
        this.updateNewImageDimensions();

      let perImgSpeed = Math.floor(
        this.state.imageNewDimensions.newContainerWidth /
          (2 * this.state.images.length)
      );

      this.setState((prev) => ({
        ...prev,
        renderHotSpots: !this.state.renderHotSpots,
        dragSpeed: perImgSpeed,
      }));

      const pageX = e.pageX ? e.pageX : e.changedTouches[0].pageX; // for touch changes
      let newIndex = null;
      if (pageX <= this.state.oldx - this.state.dragSpeed) {
        let right =
          (parseInt(this.state.imageIndex) + 1) % parseInt(this.state.noOfImg);
        newIndex = right;
      } else if (pageX >= this.state.oldx + this.state.dragSpeed) {
        let left =
          this.state.imageIndex - 1 < 0
            ? this.state.noOfImg - 1
            : this.state.imageIndex - 1;
        newIndex = left;
      }
      if (newIndex !== null && newIndex !== this.state.imageIndex) {
        // console.log({ oldIndex: this.state.imageIndex, newIndex: newIndex });
        this.setState((prev) => ({
          ...prev,
          imageIndex: newIndex,
          oldx: pageX,
          imgId: this.state.images[newIndex].imageId,
          notMoveImageOnHover: true,
        }));
      }
    } catch (error) {
      console.log(error);
      this.setState({ ...this.state, hotspotsDisplay: "block" });
    }
  };

  /**
   * Mouse grab
   * @param {*} e
   */
  handleMouseDown = (e) => {
    this.state.autoRotate = false;
    e.stopPropagation();
    e.preventDefault();
    // close modal if open
    this.setState({ ...this.state, hotSpotModal: { show: false } });
    e.target.addEventListener("mousemove", this.move);
    this.setState((showHelperText) => ({ showHelperText: false }));
  };

  /**
   * Mouse ungrab
   * @param {*} e
   */
  handleMouseUp = (e) => {
    this.state.autoRotate = false;
    e.target.removeEventListener("mousemove", this.move);
  };

  handleKeyDown = (e) => {
    try {
      if (!this.state.imageNewDimensions.isNewDimensionsUpdated)
        this.updateNewImageDimensions();

      this.setState({
        ...this.state,
        renderHotSpots: !this.state.renderHotSpots,
        dragSpeed: 3,
      });

      let newIndex = null;
      if (e.code === "ArrowLeft") {
        // Navigate to the previous image
        let right =
          (parseInt(this.state.imageIndex) + 1) % parseInt(this.state.noOfImg);
        newIndex = right;
      } else if (e.code === "ArrowRight") {
        // Navigate to the next image
        let left =
          this.state.imageIndex - 1 < 0
            ? this.state.noOfImg - 1
            : this.state.imageIndex - 1;
        newIndex = left;
      }

      if (newIndex !== null && newIndex !== this.state.imageIndex) {
        this.setState((prev) => ({
          ...prev,
          imageIndex: newIndex,
          imgId: this.state.images[newIndex].imageId,
        }));
      }
    } catch (err) {
      console.log(err);
    }
  };

  /**
   * Get img container dimensions
   */
  updateNewImageDimensions = () => {
    try {
      const containerRef = document.getElementById("imageActualContainer");
      if (!containerRef) return;
      const containerCoordinates = containerRef.getBoundingClientRect();
      const container = {
        width: containerCoordinates.width,
        height: containerCoordinates.height,
      };
      const image = {
        width: containerRef.children[0].naturalWidth,
        height: containerRef.children[0].naturalHeight,
      };
      let ratio_diff = parseFloat(container.height) / parseFloat(image.height);
      let newImage = {
        width: parseFloat(ratio_diff) * image.width,
        height: parseFloat(ratio_diff) * image.height,
      };
      let padding = (container.width - newImage.width) / 2;
      if (padding < 0) {
        ratio_diff = parseFloat(container.width) / parseFloat(image.width);

        newImage = {
          width: ratio_diff * image.width,
          height: ratio_diff * image.height,
        };
        padding = (container.height - newImage.height) / 2;
        // console.log({'ratio_diff': ratio_diff,'image':image,'container':container,'newImage': newImage,'padding': padding})
        this.setState((prev) => ({
          ...prev,
          imageNewDimensions: {
            isNewDimensionsUpdated: true,
            isPadByWidth: false,
            newImgWidth: newImage.width || 1,
            newImgHeight: newImage.height || 1,
            newContainerWidth: container.width || 1,
            newContainerHeight: container.height || 1,
            paddingHalf: padding,
            notMoveImageOnHover: true,
          },
        }));
      } else {
        this.setState((prev) => ({
          ...prev,
          imageNewDimensions: {
            isNewDimensionsUpdated: true,
            isPadByWidth: true,
            newImgWidth: newImage.width || 1,
            newImgHeight: newImage.height || 1,
            newContainerWidth: container.width || 1,
            newContainerHeight: container.height || 1,
            paddingHalf: padding,
          },
        }));
        // console.log({'ratio_diff': ratio_diff,'image':image,'container':container,'newImage': newImage,'padding': padding})
      }
    } catch (error) {
      console.log(error)
    }
  };

  calculateLeftAsPerAspect = (leftPercentageFromImageLeft) => {
    try {
      // debugger
      if (!leftPercentageFromImageLeft) return 50;
      if (!this.state.imageNewDimensions.isNewDimensionsUpdated)
        this.updateNewImageDimensions();
      let newImageDimensions = this.state.imageNewDimensions;
      if (!newImageDimensions.isPadByWidth) return leftPercentageFromImageLeft;
      // convert to pixels
      const leftPixelFromImgLeft =
        (leftPercentageFromImageLeft * newImageDimensions.newImgWidth) / 100;
      const newLeftFromContainer =
        leftPixelFromImgLeft + newImageDimensions.paddingHalf;
      const newPercentFromContainer =
        (newLeftFromContainer / newImageDimensions.newContainerWidth) * 100;
      return newPercentFromContainer;
    } catch (error) {
      console.log(error);
    }
  };

  calculateTopAsPerAspect = (topPercentageFromImageTop) => {
    try {
      if (!topPercentageFromImageTop) return 50;

      if (!this.state.imageNewDimensions.isNewDimensionsUpdated)
        this.updateNewImageDimensions();
      let newImageDimensions = this.state.imageNewDimensions;
      if (newImageDimensions.isPadByWidth) return topPercentageFromImageTop;
      // convert to pixels
      const topPixelFromImgTop =
        (topPercentageFromImageTop * newImageDimensions.newImgHeight) / 100;
      const newTopFromContainer =
        topPixelFromImgTop + newImageDimensions.paddingHalf;
      const newPercentFromContainer =
        (newTopFromContainer / newImageDimensions.newContainerHeight) * 100;
      return newPercentFromContainer;
    } catch (error) {
      console.log(error);
    }
  };

  handleHotSpotClick = async (e, hotspotObjKey, x = 0, y = 0) => {
    try {
      if (e) e.preventDefault();
      let activeHotspot = true;
      if (this.playerType == "sbs") activeHotspot = false;
      let modalListKeys = [...this.state.modalList.keys()];
      let modalList = [...this.state.modalList.entries()];
      let index = modalListKeys?.findIndex(
        (hotspotkey) => hotspotkey == hotspotObjKey
      );
      if (
        /iphone|ipod|ipad|android|ie|blackberry|fennec/.test(
          navigator.userAgent.toLowerCase()
        ) ||
        (navigator.userAgent.includes("Mac") && "ontouchend" in document) ||
        this.mobileMode
      ) {
        // console.log("message before post");
        var layoutType = "mobile";
        window.parent.postMessage(
          {
            index: index,
            state: this.state,
            closeUpList: modalList,
            func: "previewPOIMobile",
          },
          "*"
        );
      } else {
        let displayPOIPreviewMini = true;
        if (document.querySelector("#bigModelView")) {
          displayPOIPreviewMini =
            document.querySelector("#bigModelView").style.display == "none";
        }
        this.setState(
          {
            ...this.state,
            goToSlide: index,
            activeHotspot: activeHotspot,
            selectedHotspotObjKey: hotspotObjKey,
            hotspotActiveValue: { x, y },
          },
          () => {
            let draggablePOIPreview = document.querySelector(
              "#draggablePOIPreview"
            );
            if (draggablePOIPreview && displayPOIPreviewMini) {
              draggablePOIPreview.style.display = "none";
              const guideLine = document.querySelector(".guide-line");
              guideLine.style.display = "none";
            }
          }
        );
        if (!activeHotspot) {
          // window.parent.postMessage(
          //     {
          //         index:   index,
          //         state:   this.state,
          //         func: "previewPOI"
          //     },
          //     "*");
          this.activateHotspot(e.target.getAttribute("id"));
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  activateHotspot = async (hotspot_id, keyobj, image_id) => {
    if (this.playerType == "sbs") {
      window.setTimeout(function () {
        let activePOI = document.querySelector("[id='" + hotspot_id + "']");
        if (activePOI && activePOI != undefined && activePOI != "undefined") {
          activePOI.classList.add("activePOI");
          //activePOI.style.setProperty("width", "35px", "important");
          //activePOI.style.setProperty("height", "35px", "important");
        }
      }, 500);
      let allpois = document.querySelectorAll(".ez360POI");
      if (allpois && allpois != "undefined") {
        allpois.forEach((element) => {
          element.classList.remove("activePOI");
          element.style.setProperty("width", "20px", "important");
          element.style.setProperty("height", "20px", "important");
        });
      }
    }
  };

  handleExternalHotSpotClick = async (
    image_id,
    hotspot_id,
    keyobj,
    imgindex,
    x = 0,
    y = 0
  ) => {
    try {
      let index = parseInt(imgindex);
      await this.setState({
        ...this.state,
        //index: index,
        goToSlide: index,
        activeHotspot: true,
        selectedImageID: this.state.images[image_id].imageId,
        imgId: this.state.images[image_id].imageId,
        selectedHotspotObjKey: keyobj,
        imageIndex: image_id,
      });
      //this.handleHotSpotClick(undefined, keyobj, 0, 0);
    } catch (error) {
      console.log(error);
    }
  };

  handleExternalClose = async () => {
    try {
      this.setState({
        ...this.state,
        hotSpotModal: { show: false },
        activeHotspot: null,
        selectedHotspotObjKey: null,
      });
    } catch (error) {
      console.log(error);
    }
  };
  /**
   * touch grab
   * @param {*} e
   */
  handleTouchStarted = (e) => {
    // console.log("touch event");
    if (e) e.stopPropagation();
    // if(e)e.preventDefault()
    this.setState({ ...this.state, showHelperText: false });
    e.target.addEventListener("touchmove", this.move);
  };

  /**
   * touch ungrab
   * @param {*} e
   */
  touchEnd = (e) => {
    e.target.removeEventListener("touchmove", this.move);
  };

  /**
   * Hotspot toggle
   * @param {*} e
   */
  handleHotSpotViewToggle = (e) => {
    try {
      this.setState({
        ...this.state,
        toggleHotspotView: !this.state.toggleHotspotView,
        isZoomActive: false,
        currentZoomLevel: 100,
        activeHotspot: null,
        selectedHotspotObjKey: null,
      });
      window.parent.postMessage(
        {
          hotspotView: !this.state.toggleHotspotView,
        },
        "*"
      );
    } catch (error) {
      console.log(error)
    }
  };

  /**
   * @returns left position in pixels
   */
  computeHotSpotTogglePositionLeft = () => {
    try {
      // if padding is not by width, return 10px
      const newImageDimensions = this.state.imageNewDimensions;
      if (!newImageDimensions || !newImageDimensions.isPadByWidth) return 10;

      // else add padding + 10 pixels
      return newImageDimensions.paddingHalf + 10;
    } catch (error) {
      console.log(error);
    }
  };

  /**
   * @returns top position in pixels
   */
  computeHotSpotTogglePositionTop = () => {
    try {
      // if padding is by width, return 10px
      const newImageDimensions = this.state.imageNewDimensions;
      if (!newImageDimensions) return 10;

      let hotSpotToggleViewContainer = document.getElementById(
        "hotspot-toggle-view-id"
      );
      let containerHeight = 30;
      if (hotSpotToggleViewContainer) {
        containerHeight =
          hotSpotToggleViewContainer.getBoundingClientRect().height;
      }
      // if padding by width
      if (newImageDimensions.isPadByWidth) {
        return newImageDimensions.newImgHeight - containerHeight - 10;
      }
      // else add padding + newImageHeight - 10px (from bottom) - height os hotspotcontainer pixels
      return (
        newImageDimensions.paddingHalf +
        newImageDimensions.newImgHeight -
        containerHeight -
        10
      );
    } catch (error) {
      console.log(error);
    }
  };

  handleZoomIn = () => {
    this.setState((prevState) => ({
      ...prevState,
      isZoomActive: true,
      showHelperText: false,
      currentZoomLevel: parseInt(prevState.currentZoomLevel) + 25,
      toggleHotspotView: false,
    }));
    if (this.zoomInBtn.current) {
      this.zoomInBtn.current.click();
    }
  };

  handleZoomOut = () => {
    this.setState((prevState) => ({
      currentZoomLevel: parseInt(prevState.currentZoomLevel) - 25,
    }));
    if (this.zoomOutBtn.current) {
      this.zoomOutBtn.current.click();
    }
    if (this.state.currentZoomLevel === 125) {
      this.setState((prev) => ({
        ...prev,
        isZoomActive: false,
        toggleHotspotView: false,
      }));
    }
  };

  handleReset = () => {
    this.setState((prevState) => ({
      ...prevState,
      isZoomActive: false,
      currentZoomLevel: 100,
      toggleHotspotView: false,
    }));
    this.resetBtn.current.click();
  };

  handleZoomSlider = (value) => {
    try {
      if (value === this.state.currentZoomLevel) return;
      if (value === 100) {
        this.handleReset();
        return;
      }

      if (value < this.state.currentZoomLevel) {
        this.handleZoomOut();
      } else {
        this.handleZoomIn();
      }
    } catch (error) {}
  };
  updateState = (value) => {
    try {
      this.setState({
        ...this.state,
        showExtOrInt: value,
        isLoaded: false,
        isZoomActive: false,
        currentZoomLevel: 100,
        toggleHotspotView: false,
      });

      this.resetBtn.current.click();
    } catch (error) {}
  };
  handleOnLoad = () => {
    try {
      this.setState({ ...this.state, isLoaded: true });
    } catch (error) {}
  };
  handleMouseOver(index) {
    try {
      this.setState({
        ...this.state,
        showValue: { [index]: true },
      });
    } catch (error) {}
  }
  hideLabel() {
    try {
      this.setState({
        ...this.state,
        showValue: {},
      });
    } catch (error) {}
  }
  handleAnimationEnd = (index) => {
    // console.log('Animation finished');
    try {
      if (this.elementRef.current) {
        this.elementRef.current.style.transform = "scale(1)";
      }
    } catch (error) {}
    // Your code to run after animation finishes
  };

  openCurrentPOI = async (
    imageTag,
    hideGuideLine = true,
    mobileView = true
  ) => {
    try {
      let modalListKeys = [...this.state.modalList.keys()];
      let modalList = [...this.state.modalList.entries()];
      let index = this.state.images.findIndex(
        (obj) => obj.imageId == this.state.modalList.get(imageTag)?.image_id
      );
      let modalIndex = modalListKeys.findIndex((key) => key == imageTag);
      // console.log(
      //   this.state.modalList.get(imageTag),
      //   this.state.modalList.get(imageTag)?.image_id,
      //   index,
      //   this.state.images,
      //   "miracle?"
      // );
      let previousImagePosition = this.state.imageIndex;
      let totalImages = this.state.images.length;
      if (previousImagePosition >= totalImages - 1) {
        previousImagePosition = 1;
      }
      this.setState((prevState) => ({
        ...prevState,
        guideLineDisplay: hideGuideLine ? "none" : "block",
        hotspotsDisplay: previousImagePosition == index ? "block" : "none",
      }));
      if (index <= totalImages - 1) {
        let isHotSpotModelOpened = JSON.stringify(
          JSON.parse(this.state?.hotSpotModal?.show)
        );
        if (
          document.querySelector("#bigModelView") &&
          index != previousImagePosition
        ) {
          document.querySelector("#bigModelView").style.display = "none";
        }
        let interval = setInterval(async () => {
          let showIndexPosition = previousImagePosition;
          if (index != previousImagePosition) {
            previousImagePosition = (previousImagePosition + 1) % totalImages;
            showIndexPosition = previousImagePosition;
            await this.setState({
              ...this.state,
              hotSpotModal: { show: false },
              imageIndex: showIndexPosition,
              selectedImageID: this.state.images[showIndexPosition].imageId,
              imgId: this.state.images[showIndexPosition].imageId,
              selectedHotspotObjKey: modalListKeys[modalIndex],
            });
          } else {
            clearInterval(interval);
            setTimeout(async () => {
              await this.setState({
                ...this.state,
                hotSpotModal: { show: true },
                goToSlide: modalIndex,
                imageIndex: showIndexPosition,
                selectedImageID: this.state.images[showIndexPosition].imageId,
                imgId: this.state.images[showIndexPosition].imageId,
                selectedHotspotObjKey: modalListKeys[modalIndex],
              });
              if (
                document.querySelector("#bigModelView") &&
                isHotSpotModelOpened
              ) {
                document.querySelector("#bigModelView").style.display = "block";
              }
              if (mobileView) {
                // console.log("message before post");
                window.parent.postMessage(
                  {
                    state: this.state,
                    closeUpList: modalList,
                    func: "previewPOIMobile",
                  },
                  "*"
                );
              }
            }, 100);
          }
        }, this.spinSpeed);
      }
    } catch (error) {
       console.log(error);
    }
  };

  increment = async (hideGuideLine = true, mobileView = false) => {
    try {
      // console.log(this.state.modalList);
      let modalListKeys = [...this.state.modalList.keys()];
      let modalList = [...this.state.modalList.entries()];
      let index = this.state.images.findIndex(
        (obj) =>
          obj.imageId ==
          this.state.modalList.get(
            modalListKeys[
              this.state.goToSlide + 1 >= modalListKeys.length
                ? 0
                : this.state.goToSlide + 1
            ]
          )?.image_id
      );
      // console.log(modalListKeys, "miracle1?");
      let previousImagePosition = this.state.imageIndex;
      let totalImages = this.state.images.length;
      if (previousImagePosition >= totalImages - 1) {
        previousImagePosition = 1;
      }
      this.setState((prevState) => ({
        ...prevState,
        guideLineDisplay: hideGuideLine ? "none" : "block",
        hotspotsDisplay: previousImagePosition == index ? "block" : "none",
      }));
      if (index <= totalImages - 1) {
        let isHotSpotModelOpened = JSON.stringify(
          JSON.parse(this.state?.hotSpotModal?.show)
        );
        if (
          document.querySelector("#bigModelView") &&
          index != previousImagePosition
        ) {
          document.querySelector("#bigModelView").style.display = "none";
        }
        let interval = setInterval(async () => {
          let showIndexPosition = previousImagePosition;
          if (index != previousImagePosition) {
            previousImagePosition = (previousImagePosition + 1) % totalImages;
            showIndexPosition = previousImagePosition;
            await this.setState({
              ...this.state,
              hotSpotModal: { show: false },
              imageIndex: showIndexPosition,
              selectedImageID: this.state.images[showIndexPosition].imageId,
              imgId: this.state.images[showIndexPosition].imageId,
              selectedHotspotObjKey:
                modalListKeys[
                  this.state.goToSlide + 1 >= modalListKeys.length
                    ? 0
                    : this.state.goToSlide + 1
                ],
            });
            if (mobileView) {
              // console.log("message before post");
              window.parent.postMessage(
                {
                  index:
                    this.state.goToSlide + 1 >= modalListKeys.length
                      ? 0
                      : this.state.goToSlide + 1,
                  state: this.state,
                  closeUpList: modalList,
                  func: "previewPOIMobile",
                },
                "*"
              );
            }
          } else {
            clearInterval(interval);
            setTimeout(async () => {
              await this.setState({
                ...this.state,
                hotSpotModal: { show: true },
                goToSlide:
                  this.state.goToSlide + 1 >= modalListKeys.length
                    ? 0
                    : this.state.goToSlide + 1,
                imageIndex: showIndexPosition,
                selectedImageID: this.state.images[showIndexPosition].imageId,
                imgId: this.state.images[showIndexPosition].imageId,
                selectedHotspotObjKey:
                  modalListKeys[
                    this.state.goToSlide + 1 >= modalListKeys.length
                      ? 0
                      : this.state.goToSlide + 1
                  ],
              });
              if (
                document.querySelector("#bigModelView") &&
                isHotSpotModelOpened
              ) {
                document.querySelector("#bigModelView").style.display = "block";
              }
              if (mobileView) {
                // console.log("message before post");
                window.parent.postMessage(
                  {
                    index:
                      this.state.goToSlide + 1 >= modalListKeys.length
                        ? 0
                        : this.state.goToSlide + 1,
                    state: this.state,
                    closeUpList: modalList,
                    func: "previewPOIMobile",
                  },
                  "*"
                );
              }
            }, 100);
          }
        }, this.spinSpeed);
      }
    } catch (error) {
      console.log(error);
    }
  };

  decrement = async (hideGuideLine = true, mobileView = false) => {
    try {
      let modalListKeys = [...this.state.modalList.keys()];
      let modalList = [...this.state.modalList.entries()];
      let index = this.state.images.findIndex(
        (obj) =>
          obj.imageId ==
          this.state.modalList.get(
            modalListKeys[
              this.state.goToSlide - 1 < 0
                ? modalListKeys.length - 1
                : this.state.goToSlide - 1
            ]
          )?.image_id
      );
      let previousImagePosition = this.state.imageIndex;
      let totalImages = this.state.images.length;
      if (previousImagePosition == 0) {
        previousImagePosition = totalImages - 1;
      }
      this.setState((prevState) => ({
        ...prevState,
        guideLineDisplay: hideGuideLine ? "none" : "block",
        hotspotsDisplay: previousImagePosition == index ? "block" : "none",
      }));
      if (index >= 0 && previousImagePosition > 0) {
        let isHotSpotModelOpened = this.state?.hotSpotModal?.show;
        if (
          document.querySelector("#bigModelView") &&
          index != previousImagePosition
        ) {
          document.querySelector("#bigModelView").style.display = "none";
        }
        let interval = setInterval(async () => {
          let showIndexPosition = previousImagePosition;
          if (index != previousImagePosition) {
            previousImagePosition--;
            if (previousImagePosition < 0) {
              previousImagePosition = totalImages - 1;
            }
            showIndexPosition = previousImagePosition;
            await this.setState({
              ...this.state,
              hotSpotModal: { show: false },
              imageIndex: showIndexPosition,
              selectedImageID: this.state.images[showIndexPosition].imageId,
              imgId: this.state.images[showIndexPosition].imageId,
              selectedHotspotObjKey:
                modalListKeys[
                  this.state.goToSlide - 1 < 0
                    ? modalListKeys.length - 1
                    : this.state.goToSlide - 1
                ],
            });
            if (mobileView) {
              // console.log("message before post");
              window.parent.postMessage(
                {
                  index:
                    this.state.goToSlide - 1 < 0
                      ? modalListKeys.length - 1
                      : this.state.goToSlide - 1,
                  state: this.state,
                  closeUpList: modalList,
                  func: "previewPOIMobile",
                },
                "*"
              );
            }
          } else {
            clearInterval(interval);
            setTimeout(async () => {
              await this.setState({
                ...this.state,
                hotSpotModal: { show: true },
                goToSlide:
                  this.state.goToSlide - 1 < 0
                    ? modalListKeys.length - 1
                    : this.state.goToSlide - 1,
                imageIndex: showIndexPosition,
                selectedImageID: this.state.images[showIndexPosition].imageId,
                imgId: this.state.images[showIndexPosition].imageId,
                selectedHotspotObjKey:
                  modalListKeys[
                    this.state.goToSlide - 1 < 0
                      ? modalListKeys.length - 1
                      : this.state.goToSlide - 1
                  ],
              });
              if (
                document.querySelector("#bigModelView") &&
                isHotSpotModelOpened
              ) {
                document.querySelector("#bigModelView").style.display = "block";
              }
              if (mobileView) {
                // console.log("message before post");
                window.parent.postMessage(
                  {
                    index:
                      this.state.goToSlide - 1 < 0
                        ? modalListKeys.length - 1
                        : this.state.goToSlide - 1,
                    state: this.state,
                    closeUpList: modalList,
                    func: "previewPOIMobile",
                  },
                  "*"
                );
              }
            }, 100);
          }
        }, this.spinSpeed);
      }
    } catch (error) {
      console.log(error);
    }
  };

  focusPoint = async (index) => {
    try {
      if (index == this.state.goToSlide) return;
      let modalListKeys = [...this.state.modalList.keys()];
      let imageIndex = this.state.images.findIndex(
        (obj) =>
          obj.imageId ==
          this.state.modalList.get(modalListKeys[index])?.image_id
      );
      // if(this.state.imageIndex === imageIndex)return
      await this.setState((prev) => ({
        ...prev,
        hotSpotModal: { show: false },
        goToSlide: index,
        imageIndex: imageIndex,
        selectedImageID: this.state.images[imageIndex].imageId,
        imgId: this.state.images[imageIndex].imageId,
        selectedHotspotObjKey: modalListKeys[index],
      }));
    } catch (error) {}
  };

  Capitalize = (sentence) => {
    if (!sentence) return "";
    try {
      let words = sentence.split(" ");

      // Capitalize the first character of each word
      let capitalizedWords = words.map((word) => {
        // Capitalize the first character and concatenate with the rest of the word in lowercase
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      });

      // Join the words back into a single string
      return capitalizedWords.join(" ");
    } catch (error) {}
  };
  ConvertingPercentageToPixel = (
    valueInPercentage,
    coordinatesValue = "x",
    value
  ) => {
    try {
      if (coordinatesValue === "x") {
        // console.log(valueInPercentage,(valueInPercentage/100) *  this.state.imageNewDimensions.newImgWidth,this.state.imageNewDimensions)
        let percentageValue =
          (valueInPercentage / 100) * this.state.imageNewDimensions.newImgWidth;
        //   debugger
        // console.log(percentageValue,"x")
        return percentageValue + value;
      } else {
        // console.log(valueInPercentage,this.state.imageNewDimensions)
        let percentageValue =
          (valueInPercentage / 100) *
          this.state.imageNewDimensions.newImgHeight;
        //   debugger
        // console.log(percentageValue,"y")
        return percentageValue + value;
      }
    } catch (error) {}
  };
  isImageLoaded = () => {
    try {
      setTimeout(() => {
        if (this.state.autoRotate) {
          this.setState((prevState) => ({
            ...prevState,
            imageLoaded: true,
          }));
        } else {
          this.setState((prevState) => ({
            ...prevState,
            hotspotsDisplay: "block",
            imageLoaded: true,
          }));
        }
      }, 500);
    } catch (error) {}
  };

  setImageRef = (img, index, refArray) => {
    refArray[index] = img; // Dynamically storing the ref for each image
  };

  updateIndexValue = () => {
    try {
      if (!this?.state?.spinMotion) return;
      this.interval = setInterval(() => {
        ///0 because first imageIndex is 0 , till when value is greate than 1 ,
        if (
          (this?.state?.imageIndex == 0 || this?.state?.imageIndex - 1 > 1) &&
          !this?.state?.notMoveImageOnHover
        ) {
          this.setState((prevState) => ({
            ...prevState,
            imageIndex:
              this?.state?.imageIndex == 0
                ? this?.state?.images?.length - 1
                : this?.state?.imageIndex - 1,
          }));
        } else {
          this.clearInterval();
        }
      }, 200);
    } catch (error) {
     console.log(error);
    }
  };

  clearInterval = () => {
    try {
      if (this.interval) {
        clearInterval(this.interval);
        //   this.setState((prevState) => ({
        //     ...prevState,
        //     imageIndex : 0
        //   }));
        this.interval = null;
      }
    } catch (error) {}
  };

  handleMouseEnter = () => {
    try {
      this.updateIndexValue();
    } catch (error) {}
  };

  handleMouseLeave = () => {
    try {
      this.clearInterval();
    } catch (error) {}
  };

  render() {
    const theme = createTheme({
      components: {
        MuiSwitch: {
          styleOverrides: {
            switchBase: {
              // Controls default (unchecked) color for the thumb
              color: "#ccc",
            },
            colorPrimary: {
              "&.Mui-checked": {
                // Controls checked color for the thumb
                color: "#01BBEE",
              },
            },
            track: {
              // Controls default (unchecked) color for the track
              opacity: 1,
              backgroundColor: "#fff",
              ".Mui-checked.Mui-checked + &": {
                // Controls checked color for the track
                opacity: 1,
                backgroundColor: "#01BBEE",
              },
            },
          },
        },
      },
    });
    return window?.innerWidth > 300 ||
      !this.state.toggleHotspotView ||
      this.state.spinMotion ? (
      <div>
        {this.state.showExtOrInt === "EXT" ? (
          <div className={Styles["view-360-container"]}>
            {this.state.loading ? (
              <Loader />
            ) : (
              <div className="row justify-content-center align-items-center">
                <div
                  className={[
                    Styles["front"],
                    "d-flex",
                    "justify-content-center",
                    "align-items-center",
                  ].join(" ")}
                >
                  {this.state.images.length && this.state.lazyLoadImages ? (
                    <div
                      className={[
                        Styles[
                          this.state.imageLoaded
                            ? "slickListContainer"
                            : "slickListContainerDisable"
                        ],
                      ]}
                    >
                      <div className={[Styles["viewContainer"]]}>
                        <div
                          className={`${
                            this.state.isZoomActive ? Styles["hidden"] : ""
                          }`}
                          id="imageActualContainer"
                          onMouseEnter={this.handleMouseEnter}
                          onMouseLeave={this.handleMouseLeave}
                        >
                          {this.state?.images.length
                            ? this.state?.images?.map((img, index) => (
                                <img
                                  key={index}
                                  src={img.src}
                                  alt=""
                                  style={{
                                    display: "none",
                                    height: "10px",
                                    width: "10px",
                                  }}
                                />
                              ))
                            : null}
                          {this.state.imageLoaded ? <></> : <Loader />}
                          <img
                            src={this.state.images[this.state.imageIndex].src}
                            alt={
                              this.state.images[this.state.imageIndex]
                                ?.imageName || ""
                            }
                            id={
                              this.state.images[this.state.imageIndex].imageId
                            }
                            onMouseDown={this.handleMouseDown}
                            onMouseUp={this.handleMouseUp}
                            ref={(img) =>
                              this.setImageRef(
                                img,
                                this.state.imageIndex,
                                this.imageRefsF
                              )
                            }
                            onTouchStart={(e) => this.handleTouchStarted(e)}
                            onTouchEnd={this.handleTouchEnd}
                            draggable="false"
                            style={{ maxWidth: "100%" }}
                            onLoad={(e) => {
                              // Check if the image has already loaded
                              if (e.target.complete) {
                                this.isImageLoaded();
                              }
                            }}
                            fetchpriority="high"
                          />

                          {this.state.imageLoaded && !this.state.spinMotion ? (
                            <View360HelperText
                              showHelperText={this.state.showHelperText}
                            />
                          ) : null}
                          {this.state.activeHotspot &&
                          this.state.isAnyFocusImage ? (
                            <View360Slider
                              modalList={this.state.modalList}
                              hideModal={() =>
                                this.setState({
                                  ...this.state,
                                  hotSpotModal: { show: false },
                                  activeHotspot: null,
                                  selectedHotspotObjKey: null,
                                })
                              }
                              goToSlide={this.state.goToSlide}
                              increment={this.increment}
                              decrement={this.decrement}
                              name={
                                this.state.images[this.state.imageIndex]
                                  ?.imageName
                              }
                            />
                          ) : null}
                        </div>
                        <div
                          className={`${
                            !this.state.isZoomActive
                              ? Styles["hidden"]
                              : Styles["zoomedImageContainer"]
                          }`}
                        ></div>
                        {this.props.hotSpotMapObj.get(`${this.state.imgId}`) &&
                        this.state.toggleHotspotView &&
                        this.state.imageLoaded &&
                        this.state.lazyLoadImages &&
                        !this.state.spinMotion
                          ? [
                              ...this.props.hotSpotMapObj
                                .get(`${this.state.imgId}`)
                                .imageHotSpots.keys(),
                            ].map((hotspotObjKey, index) => {
                              if (
                                !this.props.hotSpotMapObj
                                  .get(`${this.state.imgId}`)
                                  .imageHotSpots.get(`${hotspotObjKey}`)
                                  .coordinates.x ||
                                !this.props.hotSpotMapObj
                                  .get(`${this.state.imgId}`)
                                  .imageHotSpots.get(`${hotspotObjKey}`)
                                  .coordinates.y
                              )
                                return;
                              return (
                                <div
                                  // {...triggerHandler}
                                  key={
                                    this.props.hotSpotMapObj
                                      .get(`${this.state.imgId}`)
                                      .imageHotSpots.get(`${hotspotObjKey}`)
                                      .hotSpotId
                                  }
                                  className="d-inline-flex align-items-center"
                                >
                                  {this.state.showValue?.[index] &&
                                  (this.state.selectedHotspotObjKey !==
                                    hotspotObjKey ||
                                    !this.state.isAnyFocusImage) ? (
                                    <div
                                      className={[
                                        Styles["DentIcon__container"],
                                      ]}
                                      style={{
                                        left: `calc(${this.calculateLeftAsPerAspect(
                                          this.props.hotSpotMapObj
                                            .get(`${this.state.imgId}`)
                                            .imageHotSpots.get(
                                              `${hotspotObjKey}`
                                            ).coordinates.x
                                        )}%)`,
                                        top: `calc(${this.calculateTopAsPerAspect(
                                          this.props.hotSpotMapObj
                                            .get(`${this.state.imgId}`)
                                            .imageHotSpots.get(
                                              `${hotspotObjKey}`
                                            ).coordinates.y
                                        )}% )`,
                                        transform: `translate(-17%, -21%)`,
                                      }}
                                    >
                                      <svg
                                        className={[Styles["DentIcon__wrap"]]}
                                        viewBox="0 0 55 54"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M42.3541 11.0119C37.7055 6.36331 31.4007 3.75177 24.8266 3.75177C18.2526 3.75177 11.9477 6.36331 7.29917 11.0119C2.6506 15.6604 0.0390625 21.9653 0.0390625 28.5393C0.0390625 35.1134 2.6506 41.4182 7.29917 46.0668C11.9477 50.7154 18.2526 53.3269 24.8266 53.3269C31.4007 53.3269 37.7055 50.7154 42.3541 46.0668C47.0027 41.4182 49.6142 35.1134 49.6142 28.5393C49.6142 21.9653 47.0027 15.6604 42.3541 11.0119L54.0391 -0.673096"
                                          fill="transparent"
                                          stroke="#fff"
                                          strokeWidth="1.5"
                                          onAnimationEnd={() =>
                                            this.handleAnimationEnd(index)
                                          }
                                        ></path>
                                      </svg>
                                      <label
                                        ref={this.elementRef}
                                        className={[
                                          Styles["DentIcon__label"],
                                          Styles["DentIcon__open"],
                                        ].join(" ")}
                                      >
                                        {this.Capitalize(
                                          this.props.hotSpotMapObj
                                            .get(`${this.state.imgId}`)
                                            .imageHotSpots.get(
                                              `${hotspotObjKey}`
                                            )?.reasons?.[0] ?? "info"
                                        )}
                                      </label>
                                    </div>
                                  ) : null}

                                  {this.state.selectedHotspotObjKey ===
                                    hotspotObjKey &&
                                  this.state.isAnyFocusImage ? (
                                    <>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className={[
                                          Styles["active-line-hotspot"],
                                        ]}
                                        width="100%"
                                        height="100%"
                                      >
                                        <line
                                          className="guide-line"
                                          fill="none"
                                          stroke="#fff"
                                          x1={`calc(${this.calculateLeftAsPerAspect(
                                            this.props.hotSpotMapObj
                                              .get(`${this.state.imgId}`)
                                              .imageHotSpots.get(
                                                `${hotspotObjKey}`
                                              ).coordinates.x
                                          )}% + 1.2%)`}
                                          x2={
                                            this?.state?.imageNewDimensions
                                              ?.newImgWidth
                                              ? this.state.imageNewDimensions
                                                  .newImgWidth -
                                                (this.playerType == "sbs"
                                                  ? 0
                                                  : 100)
                                              : window?.innerWidth > 1200
                                              ? window?.innerWidth - 0
                                              : window?.innerWidth -
                                                (this.playerType == "sbs"
                                                  ? 0
                                                  : 100)
                                          }
                                          y1={`calc(${this.calculateTopAsPerAspect(
                                            this.props.hotSpotMapObj
                                              .get(`${this.state.imgId}`)
                                              .imageHotSpots.get(
                                                `${hotspotObjKey}`
                                              ).coordinates.y
                                          )}% - 1%)`}
                                          y2={
                                            this.playerType == "sbs"
                                              ? "50%"
                                              : "100"
                                          }
                                          style={{
                                            zIndex: 10,
                                            display:
                                              this.state.guideLineDisplay,
                                          }}
                                          filter="url(#filter0_d_21310_177698)"
                                        ></line>
                                      </svg>
                                      <svg
                                        style={{
                                          left: `calc(${this.calculateLeftAsPerAspect(
                                            this.props.hotSpotMapObj
                                              .get(`${this.state.imgId}`)
                                              .imageHotSpots.get(
                                                `${hotspotObjKey}`
                                              ).coordinates.x
                                          )}%)`,
                                          top: `calc(${this.calculateTopAsPerAspect(
                                            this.props.hotSpotMapObj
                                              .get(`${this.state.imgId}`)
                                              .imageHotSpots.get(
                                                `${hotspotObjKey}`
                                              ).coordinates.y
                                          )}% )`,
                                          transform: `translate(-17.7%, -18.5%)`,
                                        }}
                                        className={[Styles["active-hotspot"]]}
                                      >
                                        <circle
                                          cx="50%"
                                          cy="50%"
                                          r="16.5"
                                          fillOpacity="0"
                                          stroke="#fff"
                                          style={{ zIndex: 10 }}
                                          className={[Styles["circle"]]}
                                          strokeWidth="1"
                                        ></circle>
                                      </svg>
                                    </>
                                  ) : null}
                                  <img
                                    src={
                                      "data:image/svg+xml;base64," +
                                      btoa(
                                        '<svg width="25px" height="25px" viewBox="0 0 32.00 32.00" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" fill="#01BBEE"><g id="SVGRepo_bgCarrier" stroke-width="0"><rect x="0" y="0" width="32.00" height="32.00" rx="16" fill="#FFFFFF" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>plus-circle</title> <desc>Created with Sketch Beta.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"> <g id="Icon-Set-Filled" sketch:type="MSLayerGroup" transform="translate(-466.000000, -1089.000000)" fill="#01BBEE"> <path d="M488,1106 L483,1106 L483,1111 C483,1111.55 482.553,1112 482,1112 C481.447,1112 481,1111.55 481,1111 L481,1106 L476,1106 C475.447,1106 475,1105.55 475,1105 C475,1104.45 475.447,1104 476,1104 L481,1104 L481,1099 C481,1098.45 481.447,1098 482,1098 C482.553,1098 483,1098.45 483,1099 L483,1104 L488,1104 C488.553,1104 489,1104.45 489,1105 C489,1105.55 488.553,1106 488,1106 L488,1106 Z M482,1089 C473.163,1089 466,1096.16 466,1105 C466,1113.84 473.163,1121 482,1121 C490.837,1121 498,1113.84 498,1105 C498,1096.16 490.837,1089 482,1089 L482,1089 Z" id="plus-circle" sketch:type="MSShapeGroup"> </path> </g> </g> </g></svg>'
                                      )
                                    }
                                    className={
                                      [
                                        Styles[
                                          "slickListContainerItemcentered"
                                        ],
                                      ] + " ez360POI"
                                    }
                                    // onClick={this.handleHotSpotClick}
                                    // onTouchStart={this.handleHotSpotClick}
                                    onClick={(e) =>
                                      this.handleHotSpotClick(e, hotspotObjKey)
                                    }
                                    onMouseEnter={() =>
                                      this.handleMouseOver(index)
                                    }
                                    onMouseLeave={() => this.hideLabel()}
                                    id={
                                      this.props.hotSpotMapObj
                                        .get(`${this.state.imgId}`)
                                        .imageHotSpots.get(`${hotspotObjKey}`)
                                        ._id
                                    }
                                    alt={
                                      this.props.hotSpotMapObj
                                        .get(`${this.state.imgId}`)
                                        .imageHotSpots.get(`${hotspotObjKey}`)
                                        .hotSpotTitle
                                    }
                                    style={{
                                      display: this.state.hotspotsDisplay,
                                      left: `${this.calculateLeftAsPerAspect(
                                        this.props.hotSpotMapObj
                                          .get(`${this.state.imgId}`)
                                          .imageHotSpots.get(`${hotspotObjKey}`)
                                          .coordinates.x
                                      )}%`,
                                      top: `${this.calculateTopAsPerAspect(
                                        this.props.hotSpotMapObj
                                          .get(`${this.state.imgId}`)
                                          .imageHotSpots.get(`${hotspotObjKey}`)
                                          .coordinates.y
                                      )}%`,
                                    }}
                                    // ref={ref}
                                    draggable="false"
                                  />
                                  <span
                                    className={[
                                      Styles[
                                        this.props.hotSpotMapObj
                                          .get(`${this.state.imgId}`)
                                          .imageHotSpots.get(`${hotspotObjKey}`)
                                          .type == "hotspot"
                                          ? "slickListContainerItemcentered-span-hotspot"
                                          : "slickListContainerItemcentered-span"
                                      ],
                                    ]}
                                    style={{
                                      display: this.state.hotspotsDisplay,
                                      left: `${this.calculateLeftAsPerAspect(
                                        this.props.hotSpotMapObj
                                          .get(`${this.state.imgId}`)
                                          .imageHotSpots.get(`${hotspotObjKey}`)
                                          .coordinates.x
                                      )}%`,
                                      top: `${this.calculateTopAsPerAspect(
                                        this.props.hotSpotMapObj
                                          .get(`${this.state.imgId}`)
                                          .imageHotSpots.get(`${hotspotObjKey}`)
                                          .coordinates.y
                                      )}%`,
                                    }}
                                  />
                                </div>
                                // )}
                                // </OverlayTrigger>
                              );
                            })
                          : null}
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            )}

            {this.state.images.length && !this.state.lazyLoadImages
              ? this.state.images.map((imgData) => {
                  return (
                    <span key={imgData.src} style={{ display: "none" }}>
                      <img
                        src={imgData.src}
                        alt=""
                        style={{ display: "none" }}
                        loading="eager"
                      />
                    </span>
                  );
                })
              : null}
            {this.state.errStatus.show ? (
              <>
                {this.state.isRequestFor3DModel ? (
                  <div
                    className={[
                      Styles["fallback-ui-container"],
                      Styles["please-wait"],
                    ].join(" ")}
                  >
                    Your 3d model is being generated, kindly <br /> check back
                    after few minutes
                  </div>
                ) : (
                  <View360FallbackUI errStatus={this.state.errStatus.code} />
                )}
              </>
            ) : null}
          </div>
        ) : (
          <div
            className={[Styles["interior-container"], "container-fluid"].join(
              " "
            )}
          >
            {!this.state.isLoaded ? <Loader /> : null}
            <div className={[Styles["interior-a-frame"]]}>
              <a-scene>
                <a-assets>
                  <img
                    id="city"
                    src={this.state?.interior360Url?.[0]?.input_image_hres_url}
                    onLoad={this.handleOnLoad}
                    crossOrigin="anonymous"
                    alt=""
                  />
                </a-assets>
                <a-sky id="image-360" radius="10" src="#city"></a-sky>

                <a-entity
                  className="link"
                  geometry="primitive: plane; height: 1; width: 1"
                ></a-entity>

                <a-camera>
                  <a-cursor
                    id="cursor"
                    animation__click="property: scale; from: 0.1 0.1 0.1; to: 1 1 1; easing: easeInCubic; dur: 150; startEvents: click"
                    animation__clickreset="property: scale; to: 0.1 0.1 0.1; dur: 1; startEvents: animationcomplete__click"
                    animation__fusing="property: scale; from: 1 1 1; to: 0.1 0.1 0.1; easing: easeInCubic; dur: 150; startEvents: fusing"
                  ></a-cursor>
                </a-camera>
              </a-scene>

              {/* <ToggleButton updateState={this.updateState} value={this.state} /> */}
            </div>
          </div>
        )}
        {!this.state.loading ||
        this.state.isLoaded ||
        this.state.imageLoaded ? (
          <div className={[Styles["interior-exterior-container"]]}>
            <div className={[Styles["interior-exterior-container-panel"]]}>
              {this.state.isAnyHotSpotPresent &&
              !this.state.spinMotion &&
              !this.hideHotspotBtn ? (
                //    && this.state.imageNewDimensions.isNewDimensionsUpdated
                <div className={[Styles["hotspot-info-tag-left"]]}>
                  Hotspots
                  <ThemeProvider theme={theme}>
                    <Switch
                      onChange={this.handleHotSpotViewToggle}
                      checked={this.state.toggleHotspotView}
                      sx={{
                        "& .MuiSwitch-thumb": {
                          backgroundColor: this.state.toggleHotspotView
                            ? "#fff"
                            : "#B1B1B1", // Change thumb color when switch is on
                        },
                        "& .MuiSwitch-track": {
                          backgroundColor: "#707070", // Change track color
                        },
                        "& .css-19ock7p-MuiButtonBase-root-MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track":
                          {
                            backgroundColor: "#FFFFFF33",
                          },
                        "@media (max-width: 500px)": {
                          "& .MuiSwitch-thumb": {
                            width: 10,
                            height: 10,
                            marginTop: "5px",
                          },
                          "& .MuiSwitch-track": {
                            height: 8,
                            marginTop: "3px",
                            width: "25px",
                          },
                        },
                      }}
                      className={[Styles["customSwitchTrack"]]}
                    />
                  </ThemeProvider>
                </div>
              ) : null}
              {this.state.isAnyHotSpotPresent &&
              this.state.imageNewDimensions.isNewDimensionsUpdated &&
              this.state?.interior360Url?.length > 0 ? (
                <div className={[Styles["line"]]}></div>
              ) : null}
              {this.state?.interior360Url?.length > 0 ? (
                <ToggleButton
                  updateState={this.updateState}
                  value={this.state}
                />
              ) : null}
            </div>
          </div>
        ) : null}
        {!this.state.loading || this.state.isLoaded ? (
          <div className={[Styles["interior-exterior-container-mobile-view"]]}>
            {/* {this.state?.interior360Url?.length > 0 ? <ToggleButton updateState={this.updateState} value={this.state} mobileView = {true}/> : null} */}
            {this.state.isAnyHotSpotPresent &&
            !this.state.spinMotion &&
            !this.hideHotspotBtn ? (
              <div className={[Styles["hotspot-info-tag-left-mobile-view"]]}>
                Hotspots
                <Switch
                  onChange={this.handleHotSpotViewToggle}
                  checked={this.state.toggleHotspotView}
                  sx={{
                    "& .MuiSwitch-thumb": {
                      backgroundColor: this.state.toggleHotspotView
                        ? "#4600F2"
                        : undefined, // Change thumb color when switch is on
                    },
                    "@media (max-width: 500px)": {
                      "& .MuiSwitch-thumb": {
                        width: 10,
                        height: 10,
                        marginTop: "5px",
                      },
                      "& .MuiSwitch-track": {
                        height: 8,
                        marginTop: "3px",
                        width: "25px",
                      },
                    },
                  }}
                  className={[Styles["customSwitchTrack"]]}
                />
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    ) : (
      <div
        className={[Styles["view-360-mobile"]]}
        style={{
          height: `${
            window?.innerHeight ? `${window?.innerHeight}px` : "100%"
          }`,
        }}
      >
        {this.state.showExtOrInt === "EXT" ? (
          <div className={Styles["view-360-container-mobile"]}>
            {this.state.loading ? (
              <Loader />
            ) : (
              <>
                {(!this.state.loading || this.state.isLoaded) &&
                !this.state.activeHotspot &&
                this.state.isAnyFocusImage ? (
                  <div
                    className={[
                      Styles["interior-exterior-container-mobile-view"],
                    ]}
                  >
                    {this.state.isAnyHotSpotPresent && !this.hideHotspotBtn ? (
                      <div
                        className={[
                          Styles["hotspot-info-tag-left-mobile-view"],
                        ]}
                      >
                        Hotspots
                        <Switch
                          onChange={this.handleHotSpotViewToggle}
                          checked={this.state.toggleHotspotView}
                          sx={{
                            "& .MuiSwitch-thumb": {
                              backgroundColor: this.state.toggleHotspotView
                                ? "#4600F2"
                                : undefined,
                            },
                            "@media (max-width: 500px)": {
                              "& .MuiSwitch-thumb": {
                                width: 10,
                                height: 10,
                                marginTop: "5px",
                              },
                              "& .MuiSwitch-track": {
                                height: 8,
                                marginTop: "3px",
                                width: "25px",
                              },
                            },
                          }}
                          className={[Styles["customSwitchTrack"]]}
                        />
                      </div>
                    ) : null}
                  </div>
                ) : null}
                <div
                  style={
                    this.state.activeHotspot && this.state.isAnyFocusImage
                      ? {
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                          height: "100%",
                          justifyContent: "space-between",
                        }
                      : {
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                          height: "100%",
                          justifyContent: "center",
                        }
                  }
                >
                  {/* <div className="col-11" style={{...customStyle.maxHeight}}> */}
                  {this.state.activeHotspot && this.state.isAnyFocusImage ? (
                    <MobileViewSlider
                      modalList={this.state.modalList}
                      hideModal={() =>
                        this.setState({
                          ...this.state,
                          activeHotspot: null,
                          selectedHotspotObjKey: null,
                        })
                      }
                      goToSlide={this.state.goToSlide}
                      updateFocusPoint={this.focusPoint}
                      increment={this.increment}
                      decrement={this.decrement}
                      name={this.state.images[this.state.imageIndex]?.imageName}
                    />
                  ) : null}
                  <div
                    className={[
                      Styles["front"],
                      "d-flex",
                      "justify-content-center",
                      "align-items-center",
                    ].join(" ")}
                  >
                    {this.state.images.length && this.state.lazyLoadImages ? (
                      <div
                        className={[
                          Styles[
                            this.state.imageLoaded
                              ? "slickListContainerMobileView"
                              : "slickListContainerMobileDisable"
                          ],
                        ]}
                      >
                        <div className={[Styles["viewContainer"]]}>
                          <div
                            className={`${
                              this.state.isZoomActive ? Styles["hidden"] : ""
                            }`}
                            id="imageActualContainer"
                          >
                            {this.state?.images.length
                              ? this.state?.images?.map((img, index) => (
                                  <img
                                    key={index}
                                    src={img.src}
                                    alt=""
                                    style={{
                                      display: "none",
                                      height: "2px",
                                      width: "2px",
                                    }}
                                  />
                                ))
                              : null}
                            <img
                              src={
                                this.state.images[this.state.imageIndex]?.src
                              }
                              alt={
                                this.state.images[this.state.imageIndex]
                                  ?.imageName || ""
                              }
                              id={
                                this.state.images[this.state.imageIndex].imageId
                              }
                              onMouseDown={this.handleMouseDown}
                              onMouseUp={this.handleMouseUp}
                              ref={(img) =>
                                this.setImageRef(
                                  img,
                                  this.state.imageIndex,
                                  this.imageRefsS
                                )
                              }
                              onTouchStart={(e) => this.handleTouchStarted(e)}
                              style={{ maxWidth: "100%" }}
                              onLoad={(e) => {
                                // Check if the image has already loaded
                                if (e.target.complete) {
                                  this.isImageLoaded(
                                    this.state.images[this.state.imageIndex]
                                      .imageId
                                  );
                                }
                              }}
                              onTouchEnd={this.handleTouchEnd}
                              draggable="false"
                            />
                          </div>
                          {/* <div className={`${!this.state.isZoomActive ? Styles['hidden'] : Styles['zoomedImageContainer']}`}> */}
                          {/* <TransformWrapper>
                                                                            {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                                                                                <React.Fragment>
                                                                                    <div>
                                                                                        <button
                                                                                            style={{ display: 'none' }}
                                                                                            ref={this.zoomInBtn} onClick={() => zoomIn()}>
                                                                                            +
                                                                                        </button>
                                                                                        <button
                                                                                            style={{ display: 'none' }}
                                                                                            ref={this.zoomOutBtn} onClick={() => zoomOut()}>
                                                                                            -
                                                                                        </button>
                                                                                        <button
                                                                                            style={{ display: 'none' }}
                                                                                            ref={this.resetBtn} onClick={() => resetTransform()}>
                                                                                            x
                                                                                        </button>
                                                                                    </div>
                                                                                    <TransformComponent>
                                                                                        <img
                                                                                            src={this.state.images[this.state.imageIndex].src}
                                                                                            alt={this.state.images[this.state.imageIndex]?.imageName || ''}
                                                                                            id={this.state.images[this.state.imageIndex].imageId}
                                                                                            draggable="false"
                                                                                            loading='eager'
                                                                                        />
                                                                                    </TransformComponent>
                                                                                </React.Fragment>
                                                                            )}
                                                                        </TransformWrapper > */}
                          {/* </div> */}
                          {/* {console.log('bb33c7dbf8f34b91887683f1ae86780f',[...this.props?.hotSpotMapObj.get(`${this.state.imgId}`).imageHotSpots.keys()])} */}
                          {this.props.hotSpotMapObj.get(
                            `${this.state.imgId}`
                          ) &&
                          this.state.toggleHotspotView &&
                          this.state.imageLoaded
                            ? [
                                ...this.props.hotSpotMapObj
                                  .get(`${this.state.imgId}`)
                                  .imageHotSpots.keys(),
                              ].map((hotspotObjKey, index) => {
                                if (
                                  !this.props.hotSpotMapObj
                                    .get(`${this.state.imgId}`)
                                    .imageHotSpots.get(`${hotspotObjKey}`)
                                    .coordinates.x ||
                                  !this.props.hotSpotMapObj
                                    .get(`${this.state.imgId}`)
                                    .imageHotSpots.get(`${hotspotObjKey}`)
                                    .coordinates.y
                                )
                                  return;
                                // if(this.state.activeImageIdHotspot !==  this.state.imgId && !this.state.activeHotspot)return;
                                // console.log({hotspotObjKey},this.state.selectedHotspotObjKey)
                                return (
                                  //     <OverlayTrigger
                                  //         placement="top"
                                  //         overlay={
                                  //             <Tooltip id="button-tooltip-2">
                                  //                 {/* {
                                  //     this.props.hotSpotMapObj.get(`${this.state.imgId}`).imageHotSpots.get(`${hotspotObjKey}`).hotSpotTitle
                                  // } */}
                                  //             </Tooltip>
                                  //         }
                                  //         key={this.props.hotSpotMapObj.get(`${this.state.imgId}`).imageHotSpots.get(`${hotspotObjKey}`).hotSpotId}
                                  //     >
                                  //         {({ ref, ...triggerHandler }) => (
                                  <div
                                    key={
                                      this.props.hotSpotMapObj
                                        .get(`${this.state.imgId}`)
                                        .imageHotSpots.get(`${hotspotObjKey}`)
                                        .hotSpotId
                                    }
                                    className="d-inline-flex align-items-center"
                                  >
                                    {/* {(this.state.showValue?.[index] && (this.state.selectedHotspotObjKey !== hotspotObjKey || !this.state.isAnyFocusImage)) ? <div className={[Styles["DentIcon__container"]]}
                                                                                                    style={{
                                                                                                        left: `calc(${this.calculateLeftAsPerAspect(this.props.hotSpotMapObj.get(`${this.state.imgId}`).imageHotSpots.get(`${hotspotObjKey}`).coordinates.x)}%)`,
                                                                                                        top: `calc(${this.calculateTopAsPerAspect(this.props.hotSpotMapObj.get(`${this.state.imgId}`).imageHotSpots.get(`${hotspotObjKey}`).coordinates.y)}% )`,
                                                                                                        transform: `translate(-17%, -21%)`
                                                                                                    }}
                                                                                                ><svg
                                                                                                    className={[Styles["DentIcon__wrap"]]} viewBox="0 0 55 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                        <path
                                                                                                            d="M42.3541 11.0119C37.7055 6.36331 31.4007 3.75177 24.8266 3.75177C18.2526 3.75177 11.9477 6.36331 7.29917 11.0119C2.6506 15.6604 0.0390625 21.9653 0.0390625 28.5393C0.0390625 35.1134 2.6506 41.4182 7.29917 46.0668C11.9477 50.7154 18.2526 53.3269 24.8266 53.3269C31.4007 53.3269 37.7055 50.7154 42.3541 46.0668C47.0027 41.4182 49.6142 35.1134 49.6142 28.5393C49.6142 21.9653 47.0027 15.6604 42.3541 11.0119L54.0391 -0.673096"
                                                                                                            fill="transparent" stroke="#fff" stroke-width="1.5"
                                                                                                            onAnimationEnd={() => this.handleAnimationEnd(index)}

                                                                                                        ></path>
                                                                                                    </svg>

                                                                                                    <label ref={this.elementRef} className={[Styles["DentIcon__label"], Styles["DentIcon__open"]].join(' ')}>{this.Capitalize(this.props.hotSpotMapObj.get(`${this.state.imgId}`).imageHotSpots.get(`${hotspotObjKey}`)?.reasons[0] ?? 'info')}</label>
                                                                                                </div> : null} */}

                                    {this.state.selectedHotspotObjKey ===
                                      hotspotObjKey &&
                                    this.state.isAnyFocusImage ? (
                                      <>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          className={[
                                            Styles["active-line-hotspot"],
                                          ]}
                                          width="100%"
                                          height="100%"
                                          role="presentation"
                                          aria-hidden="true"
                                          style={{
                                            position: "absolute",
                                            height: "700px",
                                            top: `-${
                                              (window?.innerHeight || 900) /
                                              2.35
                                            }px`,
                                          }}
                                        >
                                          <defs>
                                            {/* Define the filter with drop shadow */}
                                            <filter
                                              id="drop-shadow"
                                              x="-20%"
                                              y="-20%"
                                              width="140%"
                                              height="140%"
                                            >
                                              <feDropShadow
                                                dx="0"
                                                dy="0"
                                                stdDeviation="6"
                                                flood-color="rgba(0, 0, 0, 0.32)"
                                              />
                                            </filter>
                                          </defs>

                                          {/* Apply the drop shadow filter to the line */}
                                          <line
                                            className="guide-line"
                                            fill="none"
                                            stroke="#fff"
                                            x1="187.5"
                                            x2={this.ConvertingPercentageToPixel(
                                              this.props.hotSpotMapObj
                                                .get(`${this.state.imgId}`)
                                                .imageHotSpots.get(
                                                  `${hotspotObjKey}`
                                                ).coordinates.x,
                                              "x",
                                              10
                                            )}
                                            y1="0"
                                            y2={this.ConvertingPercentageToPixel(
                                              this.props.hotSpotMapObj
                                                .get(`${this.state.imgId}`)
                                                .imageHotSpots.get(
                                                  `${hotspotObjKey}`
                                                ).coordinates.y,
                                              "y",
                                              (window?.innerHeight || 900) /
                                                2.36
                                            )}
                                            style={{
                                              filter: "url(#drop-shadow)",
                                              display:
                                                this.state.guideLineDisplay,
                                            }}
                                            strokeWidth="1.3"
                                          ></line>
                                        </svg>
                                        <svg
                                          style={{
                                            left: `calc(${this.calculateLeftAsPerAspect(
                                              this.props.hotSpotMapObj
                                                .get(`${this.state.imgId}`)
                                                .imageHotSpots.get(
                                                  `${hotspotObjKey}`
                                                ).coordinates.x
                                            )}%)`,
                                            top: `calc(${this.calculateTopAsPerAspect(
                                              this.props.hotSpotMapObj
                                                .get(`${this.state.imgId}`)
                                                .imageHotSpots.get(
                                                  `${hotspotObjKey}`
                                                ).coordinates.y
                                            )}% )`,
                                            transform: `translate(-17.7%, -18.5%)`,
                                          }}
                                          className={[Styles["active-hotspot"]]}
                                        >
                                          <circle
                                            cx="50%"
                                            cy="50%"
                                            r="16.5"
                                            fillOpacity="0"
                                            stroke="#fff"
                                            style={{ zIndex: 10 }}
                                            className={[Styles["circle"]]}
                                            strokeWidth="1.3"
                                          ></circle>
                                        </svg>
                                        {/* <svg xmlns="http://www.w3.org/2000/svg" style={{left: `calc(${this.calculateLeftAsPerAspect(this.props.hotSpotMapObj.get(`${this.state.imgId}`).imageHotSpots.get(`${hotspotObjKey}`).coordinates.x)}%)`, 
                                                                                            top: `calc(${this.calculateTopAsPerAspect(this.props.hotSpotMapObj.get(`${this.state.imgId}`).imageHotSpots.get(`${hotspotObjKey}`).coordinates.y)}% )`,
                                                                                            transform: `translate(6.3%, -99.5%)`,
                                                                                            position: 'absolute'}} class="DentListModalDesktop__canvas" width="400" height="400" role="presentation" aria-hidden="true"> */}
                                        {/* <line x1="0" y1="400" x2="400" y2="0" stroke="#fff" /> */}
                                        {/* </svg> */}
                                      </>
                                    ) : null}
                                    <img
                                      src={
                                        "data:image/svg+xml;base64," +
                                        btoa(
                                          '<svg width="100px" height="100px" viewBox="0 0 32.00 32.00" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns" fill="#01BBEE"><g id="SVGRepo_bgCarrier" stroke-width="0"><rect x="0" y="0" width="32.00" height="32.00" rx="16" fill="#FFFFFF" strokewidth="0"></rect></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>plus-circle</title> <desc>Created with Sketch Beta.</desc> <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage"> <g id="Icon-Set-Filled" sketch:type="MSLayerGroup" transform="translate(-466.000000, -1089.000000)" fill="#01BBEE"> <path d="M488,1106 L483,1106 L483,1111 C483,1111.55 482.553,1112 482,1112 C481.447,1112 481,1111.55 481,1111 L481,1106 L476,1106 C475.447,1106 475,1105.55 475,1105 C475,1104.45 475.447,1104 476,1104 L481,1104 L481,1099 C481,1098.45 481.447,1098 482,1098 C482.553,1098 483,1098.45 483,1099 L483,1104 L488,1104 C488.553,1104 489,1104.45 489,1105 C489,1105.55 488.553,1106 488,1106 L488,1106 Z M482,1089 C473.163,1089 466,1096.16 466,1105 C466,1113.84 473.163,1121 482,1121 C490.837,1121 498,1113.84 498,1105 C498,1096.16 490.837,1089 482,1089 L482,1089 Z" id="plus-circle" sketch:type="MSShapeGroup"> </path> </g> </g> </g></svg>'
                                        )
                                      }
                                      className={[
                                        Styles[
                                          "slickListContainerItemcentered"
                                        ],
                                      ]}
                                      // onClick={this.handleHotSpotClick}
                                      // onTouchStart={this.handleHotSpotClick}
                                      onClick={(e) =>
                                        this.handleHotSpotClick(
                                          e,
                                          hotspotObjKey,
                                          `${this.calculateLeftAsPerAspect(
                                            this.props.hotSpotMapObj
                                              .get(`${this.state.imgId}`)
                                              .imageHotSpots.get(
                                                `${hotspotObjKey}`
                                              ).coordinates.x
                                          )}%`,
                                          `${this.calculateLeftAsPerAspect(
                                            this.props.hotSpotMapObj
                                              .get(`${this.state.imgId}`)
                                              .imageHotSpots.get(
                                                `${hotspotObjKey}`
                                              ).coordinates.y
                                          )}%`
                                        )
                                      }
                                      onMouseEnter={() =>
                                        this.handleMouseOver(index)
                                      }
                                      onMouseLeave={() => this.hideLabel()}
                                      id={
                                        this.props.hotSpotMapObj
                                          .get(`${this.state.imgId}`)
                                          .imageHotSpots.get(`${hotspotObjKey}`)
                                          .hotSpotId
                                      }
                                      alt={
                                        this.props.hotSpotMapObj
                                          .get(`${this.state.imgId}`)
                                          .imageHotSpots.get(`${hotspotObjKey}`)
                                          .hotSpotTitle
                                      }
                                      style={{
                                        display: this.state.hotspotsDisplay,
                                        left: `${this.calculateLeftAsPerAspect(
                                          this.props.hotSpotMapObj
                                            .get(`${this.state.imgId}`)
                                            .imageHotSpots.get(
                                              `${hotspotObjKey}`
                                            ).coordinates.x
                                        )}%`,
                                        top: `${this.calculateTopAsPerAspect(
                                          this.props.hotSpotMapObj
                                            .get(`${this.state.imgId}`)
                                            .imageHotSpots.get(
                                              `${hotspotObjKey}`
                                            ).coordinates.y
                                        )}%`,
                                      }}
                                      // ref={this.imageRef}
                                      draggable="false"
                                    />
                                    <span
                                      className={[
                                        Styles[
                                          this.props.hotSpotMapObj
                                            .get(`${this.state.imgId}`)
                                            .imageHotSpots.get(
                                              `${hotspotObjKey}`
                                            ).hotSpotTitle == "hotspot"
                                            ? "slickListContainerItemcentered-span-hotspot"
                                            : "slickListContainerItemcentered-span"
                                        ],
                                      ]}
                                      style={{
                                        display: this.state.hotspotsDisplay,
                                        left: `${this.calculateLeftAsPerAspect(
                                          this.props.hotSpotMapObj
                                            .get(`${this.state.imgId}`)
                                            .imageHotSpots.get(
                                              `${hotspotObjKey}`
                                            ).coordinates.x
                                        )}%`,
                                        top: `${this.calculateTopAsPerAspect(
                                          this.props.hotSpotMapObj
                                            .get(`${this.state.imgId}`)
                                            .imageHotSpots.get(
                                              `${hotspotObjKey}`
                                            ).coordinates.y
                                        )}%`,
                                      }}
                                    />
                                  </div>
                                  //     )}
                                  // </OverlayTrigger>
                                );
                              })
                            : null}
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </>
            )}

            <View360HelperText showHelperText={this.state.showHelperText} />
            {/* <svg xmlns="http://www.w3.org/2000/svg" className={[Styles['active-line-hotspot']]} width="100%" height="100%">
                                <line fill="none" stroke="#fff" x1={`60%`} x2={this.state.imageNewDimensions.newContainerWidth - 200} y1={'20%'} y2="83" style={{ zIndex: 10 }}></line>
                            </svg> */}
            {this.state.images.length && !this.state.lazyLoadImages
              ? this.state.images.map((imgData) => {
                  return (
                    <span key={imgData.src} style={{ display: "none" }}>
                      <img
                        src={imgData.src}
                        alt=""
                        style={{ display: "none" }}
                        loading="eager"
                      />
                    </span>
                  );
                })
              : null}
            {this.state.errStatus.show ? (
              <>
                {this.state.isRequestFor3DModel ? (
                  <div
                    className={[
                      Styles["fallback-ui-container"],
                      Styles["please-wait"],
                    ].join(" ")}
                  >
                    Your 3d model is being generated, kindly <br /> check back
                    after few minutes
                  </div>
                ) : (
                  <View360FallbackUI errStatus={this.state.errStatus.code} />
                )}
              </>
            ) : null}
          </div>
        ) : (
          <div
            className={[Styles["interior-container"], "container-fluid"].join(
              " "
            )}
          >
            {!this.state.isLoaded ? <Loader /> : null}
            <div className={[Styles["interior-a-frame"]]}>
              <a-scene>
                <a-assets>
                  <img
                    id="city"
                    src={this.state?.interior360Url?.[0]?.input_image_hres_url}
                    onLoad={this.handleOnLoad}
                    crossOrigin="anonymous"
                    alt=""
                  />
                </a-assets>
                <a-sky id="image-360" radius="10" src="#city"></a-sky>

                <a-entity
                  className="link"
                  geometry="primitive: plane; height: 1; width: 1"
                ></a-entity>

                <a-camera>
                  <a-cursor
                    id="cursor"
                    animation__click="property: scale; from: 0.1 0.1 0.1; to: 1 1 1; easing: easeInCubic; dur: 150; startEvents: click"
                    animation__clickreset="property: scale; to: 0.1 0.1 0.1; dur: 1; startEvents: animationcomplete__click"
                    animation__fusing="property: scale; from: 1 1 1; to: 0.1 0.1 0.1; easing: easeInCubic; dur: 150; startEvents: fusing"
                  ></a-cursor>
                </a-camera>
              </a-scene>

              {/* <ToggleButton updateState={this.updateState} value={this.state} /> */}
            </div>
          </div>
        )}
      </div>
    );
  }

  setFirstPic = async () => {
    // console.log("Inside Function",image_url);
    let image_url = firstPic;
    const box = document.querySelector("#imageActualContainer");
    // console.log("Inside Function box value",box);
    if(box == null){
      setTimeout(this.setFirstPic.bind(this),500);
      // console.log("Inside Function box",image_url);
    }
    else{
      box.style.backgroundImage = "url("+image_url+")";
      box.style.backgroundSize = "cover";
      box.style.backgroundPosition = "center";
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  //console.log("nilesh",state.view360Reducer)
  return {
    hotSpotMapObj: state.view360Reducer.hotSpotMapObj,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateWholeHotSpotMapObj: (hotSpotMapObj) =>
      dispatch(updateWholeHotSpotMapObj(hotSpotMapObj)),
  };
};



export default connect(mapStateToProps, mapDispatchToProps)(View360);
